import { ChangeDetectorRef, Component, KeyValueDiffers, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { ConfigMantenedorPerfiles } from "./config-mantenedor-perfiles";
import { validarRut, VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { PerfilFilter } from "src/app/models/Perfil/PerfilFilter";
import { Perfil } from "src/app/models/Perfil/Perfil";
import { PerfilService } from "src/app/services/perfil.service";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Route } from "@angular/compiler/src/core";
import { PermissionService } from "src/app/services/permission.service";
import { ThisReceiver } from "@angular/compiler";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { EmisorService } from "src/app/services/emisor.service";
import { SortType } from "@swimlane/ngx-datatable";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
   selector: "app-mantenedor-perfiles",
   templateUrl: "./mantenedor-perfiles.component.html",
   styleUrls: ["./mantenedor-perfiles.component.scss"],
})
export class MantenedorPerfilesComponent implements OnInit {
   SortType = SortType;
   public loading = false;
   public page = new Page();
   public profileFilter = new PerfilFilter();
   public rowsMantenedorProfile: Perfil[] = [];
   public configLocal = ConfigMantenedorPerfiles;
   public searchRows: any[] = [];
   public emisorId: string;
   public userId: string;
   public profileToShow: Perfil = new Perfil();
   public profileToEdit: Perfil = new Perfil();
   public profileToAdd: Perfil = new Perfil();
   private saveRows: boolean = false;
   public detailProfileModal: NgbModalRef;
   public addNewProfileModal: NgbModalRef;
   public editProfileModal: NgbModalRef;
   public ProfilesModal: NgbModalRef;
   public searchCriterio;
   @ViewChild("currentSwal") private currentSwal: SwalComponent;
   @ViewChild("notesSwal") private notesSwal: SwalComponent;
   private asignarPerfilModal: NgbModalRef;
   public selectedPerfil: Perfil = undefined;
   public componentStarted: boolean = false;
   @ViewChild("tableMobile") tableRef: any;
   public emisoresList: Emisor[] = [];
   public newProfileName: string = "";
   private closeActionsHandler: any;
   constructor(private modalService: NgbModal, public utilities: UtilitiesService, private perfilService: PerfilService, private tokenService: TokenStorageService, private ref: ChangeDetectorRef, private router: Router, private route: ActivatedRoute, public permissions: PermissionService, private emisoresService: EmisorService, private sessionUserService: SessionUserService) {
      this.userId = this.tokenService.getUser().id;
      (this.emisorId = this.tokenService.getCompany()), (this.profileFilter.activo = 1);
      this.profileFilter.nombre = "";
      this.profileFilter.emisorid = this.emisorId;
      this.profileFilter.usuarioId = this.userId;
   }

   toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedorProfile.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}

   public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }
	  
   ngOnInit(): void {
      this.sessionUserService.verificarSesionUsuario();
      this.setPageProfile({ offset: 0 });
   }
   setPageSize() {
      //this.page.currentPageSize = this.page.page
      this.setPageProfile({ offset: 0 });
   }
   setPageProfile(pageInfo) {
      this.loading = true;
      this.page.pageNumber = pageInfo.offset;
      this.page.pageNumber += 1;

      this.perfilService
         .getProfilesDataByPage(this.profileFilter, this.page)
         .subscribe(
            (pagedData) => {
               let elements = pagedData.data as Perfil[];
               this.ref.detectChanges();
               elements.forEach((row) => {});
               this.rowsMantenedorProfile = [...elements];
               this.setPageProfilefromResponse(this.page, pagedData);
               this.loading = false;
               this.ref.detectChanges();
            },
            (error) => {
               this.loading = false;
               this.currentSwal.icon = "error";
               this.currentSwal.title = "Error en la solicitud";
               this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
               this.currentSwal.fire();
            },
            () => {
               this.loading = false;
               this.componentStarted = true;
               this.ref.detectChanges();
            }
         )
         .add(() => {
            this.loading = false;
            this.ref.detectChanges();
         });
   }
   setPageProfilefromResponse(currentPage: Page, data: PagedResponse<Perfil>) {
      currentPage.pageSize = data.pageSize;
      currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
      currentPage.totalPages = data.totalPages;
      currentPage.totalElements = data.totalRecords;
   }

   profileSearchElements(nombre: string) {
      this.loading = true;
      this.perfilService.getProfilesDataByPage(this.profileFilter, this.page).subscribe(
         (result) => {
            this.loading = false;
            let elements = result.data as Perfil[];
            elements.forEach((row) => {});
            this.rowsMantenedorProfile = [...elements];
         },
         (error) => {
            this.loading = false;
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error";
            this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
            this.currentSwal.fire();
         },
         () => {
            this.loading = false;
            this.ref.detectChanges();
         }
      );
   }

   changeSearchedRowsByProfile(data) {
      if (data != null) {
         this.rowsMantenedorProfile = data;
      }
   }

   filterConcordanceByProfile(configCriterias, planFilter: PerfilFilter, eventFilter): PerfilFilter {
      configCriterias.forEach((criterio) => {
         if (criterio != eventFilter.criterio) {
            planFilter[criterio] = "";
         }
      });
      return planFilter;
   }

   searchElementsByProfileFilter(event) {
      this.profileFilter = this.filterConcordanceByProfile(this.configLocal.barraBusqueda.criteriosKeys, this.profileFilter, event);
      this.profileFilter.nombre = event.nombre != null ? event.nombre : "";
      this.profileFilter.activo = event.registroActivo ? 0 : 1;
      this.profileFilter.emisorid = this.emisorId;
      this.profileFilter[event.criterio] = event.busqueda;
      this.profileFilter = this.utilities.clearOtherFilterCriterias(event.criterio, this.profileFilter, this.configLocal);
      this.profileFilter.emisorid = event.emisorId;
      this.profileFilter.usuarioId = this.userId;
      this.setPageProfile({ offset: 0 });
   }

   getAllRowsByFilter(currentPageRef: Page, currentFilter: PerfilFilter) {
      let fullPage: Page = new Page();
      fullPage.pageSize = currentPageRef.totalElements;
      fullPage.pageNumber = 0;
      fullPage.totalElements = currentPageRef.totalElements;
      fullPage.totalPages = 1;
      this.loading = true;
      this.perfilService.getProfilesDataByPage(currentFilter, fullPage).subscribe(
         (result) => {
            let elements = result.data as Perfil[];
            this.ref.detectChanges();
            elements.forEach((row) => {});
            this.loading = false;
            this.ref.detectChanges();
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error al exportar";
            this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
            if (error.error.message) {
               this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
            }
         },
         () => {
            this.loading = false;
            this.ref.detectChanges();
         }
      );
   }
   detailModal(modalRef, row: Perfil) {
      this.loading = true;
      this.profileToShow = row;
      this.loading = false;
      this.ref.detectChanges();
      this.detailProfileModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }

   deactivateProfile(row: Perfil) {
      this.loading = true;
      this.perfilService.deactivateProfile(row.perfilId).subscribe(
         (res) => {
            if (res.data) {
               this.loading = false;
               this.ref.detectChanges();
               Swal.fire({
                  icon: "success",
                  title: "Perfil Desactivado",
                  showCloseButton: true,
                  html: "<div style='text-align:center;'><p>" + "Perfil " + row.nombre + " Desactivado" + "</p></div>",
               });

               this.setPageProfile({ offset: 0 });
            }
         },
         (err) => {
            this.loading = false;
            this.ref.detectChanges();
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error al Desactivar";
            this.currentSwal.text = "No fue posible desactivar el perfil " + row.nombre + this.utilities.setErrorMessageFromArray(err.error);
            this.currentSwal.fire();
         }
      );
   }

   activateProfile(row: Perfil) {
      this.loading = true;
      this.perfilService.activateProfile(row.perfilId).subscribe(
         (res) => {
            if (res.data) {
               Swal.fire({
                  icon: "success",
                  title: "Perfil Activado",
                  showCloseButton: true,
                  html: "<div style='text-align:center;'><p>" + "Perfil " + row.nombre + " Activado" + "</p></div>",
               });
               this.setPageProfile({ offset: 0 });

               this.loading = false;
               this.ref.detectChanges();
            }
         },
         (err) => {
            this.loading = false;
            this.ref.detectChanges();
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error al Activar";
            this.currentSwal.text = "No fue posible activar el perfil " + row.nombre + this.utilities.setErrorMessageFromArray(err.error);
            this.currentSwal.fire();
         }
      );
   }

   editModal(modalRef, item: Perfil) {
      this.loading = true;
      this.profileToEdit = new Perfil();
      this.profileToEdit.activo = item.activo;
      this.profileToEdit.nombre = item.nombre;
      this.profileToEdit.perfilId = item.perfilId;
      this.profileToEdit.isSuperAdmin = item.isSuperAdmin;
      this.loading = false;
      this.ref.detectChanges();
      this.editProfileModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }

   editProfile(form: NgForm) {
      this.loading = true;
      this.perfilService.updateProfile(this.profileToEdit).subscribe(
         (res) => {
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "success",
               title: "Perfil Actualizado",
               showCloseButton: true,
               html: "<div style='text-align:center;'><p>" + "El perfil " + this.profileToEdit.nombre + " fue actualizado" + "</p></div>",
            });
            this.setPageProfile({ offset: 0 });
            this.editProfileModal.close();
         },
         (err) => {
            this.loading = false;
            this.ref.detectChanges();
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error al Actualizar Perfil";
            this.currentSwal.text = "No fue posible actualizar el perfil " + this.profileToEdit.nombre + ", " + this.utilities.setErrorMessageFromArray(err.error);
            this.currentSwal.fire();
         }
      );
   }

   addProfileModal(modalRef) {
      this.loading = true;
      this.profileToAdd = new Perfil();
      this.loading = false;
      this.ref.detectChanges();
      this.addNewProfileModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }

   addProfile(modalRef) {
      if (modalRef.invalid) return;
      this.loading = true;
      this.perfilService.insertProfile(this.profileToAdd, this.emisorId).subscribe(
         (res) => {
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "success",
               title: "Perfil Agregado",
               showCloseButton: true,
               text: `El perfil "${this.profileToAdd.nombre}" fue agregado exitosamente.`,
            });
            this.setPageProfile({ offset: 0 });
            this.addNewProfileModal.close();
         },
         (err) => {
            this.loading = false;
            this.ref.detectChanges();
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error al agregar Perfil";
            this.currentSwal.text = `No fue posible agregar el perfil: "${this.profileToAdd.nombre}". Detalles: ${this.utilities.setErrorMessageFromArray(err.error)}`;
            this.currentSwal.fire();
         }
      );
   }
   copyModal(modalRef: any, row: Perfil): void {
      this.profileToShow = row;
      this.newProfileName = '';
      this.ProfilesModal = this.modalService.open(modalRef, {
        size: 'lg',
        centered: true,
      });
    }
    
    
    copyProfile(form: NgForm): void {
      if (form.invalid) return;
    
      this.loading = true;
      const newProfile = new Perfil();
      newProfile.perfilId = this.profileToShow.perfilId;
      newProfile.nombre = this.newProfileName;
      this.perfilService.copyProfile(newProfile, this.emisorId).subscribe(
        (res) => {
           this.loading = false;
           this.ref.detectChanges();
           Swal.fire({
              icon: 'success',
              title: 'Perfil Copiado',
              text: `El perfil "${this.profileToShow.nombre}" fue copiado exitosamente como "${this.newProfileName}".`,
              showCloseButton: true,
            });
            this.setPageProfile({ offset: 0 });
            this.ProfilesModal.close();

        },
        (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error al copiar Perfil',
            text: `No fue posible copiar el perfil: ${this.profileToShow.nombre}. Detalles: ${this.utilities.setErrorMessageFromArray(err.error)}`,
          });
          this.loading = false;
          this.ref.detectChanges();
        }
      );
    }
    
   permissionList(row: Perfil) {
      this.router.navigate(["/configuracion/perfiles/permisos"], {
         queryParams: { perfilId: row.perfilId, perfilNombre: row.nombre },
      });
   }

   openAsignarPerfilModal(modalRef, row) {
      this.selectedPerfil = row;
      this.asignarPerfilModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }

   closeAsignarPerfilModal() {
      this.asignarPerfilModal.close();
   }

   toggleExpandRow(row) {
      this.tableRef.rowDetail.toggleExpandRow(row);
   }

   getFullEmisoresList() {
      this.loading = true;
      this.emisoresService.getData().subscribe(
         (result) => {
            let emisores = result.data;
            // let emisorService = new Emisor();
            // emisorService.razonSocial = "SERVICES";
            // emisorService.emisorId = null;
            // emisores.push(emisorService);
            this.emisoresList = emisores;
            this.ref.detectChanges();
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "error",
               title: "Error en emisores",
               text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
            });
         }
      );
   }
}
